import { FC } from 'react'
import { rebuildDeliveries } from 'api'
import { useToasts } from 'react-toast-notifications'

import styles from './DropRequests.module.scss'

import List from 'backoffice/components/DropRequests/List'
import RecentGpsPetitionsBox from 'backoffice/components/DropRequests/components/RecentGpsPetitionsBox'
import RecentDraftsBox from 'backoffice/components/DropRequests/components/RecentDraftsBox'

import { ReactComponent as RefreshIcon } from 'images/icons/refresh.svg'

import { ActionModalContextProvider } from 'backoffice/components/DropRequests/Modals/ConfirmationModal/ActionModalContext'
import { Helmet } from 'react-helmet'

const DropRequests: FC = () => {
  const { addToast } = useToasts()

  const rebuildDeliveriesPage = () => {
    rebuildDeliveries()
      .then(() => {
        addToast(`poap.delivery rebuilt successfully`, {
          appearance: 'success',
          autoDismiss: true,
        })
      })
      .catch((e) => {
        addToast('poap.delivery failed to rebuild. \n' + e.message, {
          appearance: 'error',
          autoDismiss: false,
        })
      })
  }

  return (
    <ActionModalContextProvider>
      <Helmet>
        <title>POAP - Manage Petitions</title>
        <meta property="og:title" content="POAP - Manage Petitions" />
      </Helmet>
      <div className={styles.pageHeader}>
        <h1 className={styles.pageTitle}>Manage Petitions</h1>
        <button className={styles.buttonRebuild} onClick={rebuildDeliveriesPage}>
          <span className={styles.buttonRebuildText}>Rebuild poap.delivery</span>
          <RefreshIcon width={24} height={24} className={styles.refreshIcon} />
        </button>
      </div>
      <RecentGpsPetitionsBox />
      <RecentDraftsBox />
      <List />
    </ActionModalContextProvider>
  )
}

export { DropRequests }
